import type { SalesFunnelFilterDto } from '@app/api/SalesFunnels';

import type { TreeDataNode } from 'antd';
import type { CSSProperties } from 'react';

// The stage color swatch is rendered inside an antd Tree dropdown (portal), so
// scoped SCSS cannot reach it; inline styles are used, mirroring the legacy
// funnel tree mapper.
const STAGE_COLOR_SWATCH_STYLE: CSSProperties = {
  display: 'inline-block',
  width: 10,
  height: 10,
  marginRight: 6,
  borderRadius: 2,
};

// Maps the modern `SalesFunnels/ListForFilters` dictionary into tree data for
// the Leads registry funnel filter. Leads-local equivalent of the legacy
// `mapFunnelsToTreeData` (which imports a legacy `NFunnels` type): funnel nodes
// are non-selectable parents, stage nodes are selectable leaves keyed by stage
// id (the value sent as `SalesFunnelsStages`).
export const mapSalesFunnelsToTreeData = (
  funnels: SalesFunnelFilterDto[]
): TreeDataNode[] =>
  funnels.map(({ Id, Name, Stages }) => ({
    key: `funnel-${Id}`,
    title: Name ?? '',
    selectable: false,
    children: (Stages ?? []).map((stage) => ({
      key: stage.Id,
      isLeaf: true,
      title: (
        <span>
          <span
            style={{
              ...STAGE_COLOR_SWATCH_STYLE,
              backgroundColor: stage.Color ?? 'transparent',
            }}
          />
          {stage.Name}
        </span>
      ),
    })),
  }));
